import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

// The abstract theme has no token for an amber/mid "notice" content or stroke
// colour, so the 3 to 4 band falls back to a local accessible amber (carried over
// from the original Partner page implementation). The low/high bands map onto the
// theme's negative/positive tokens.
const AMBER_BORDER = '#F6BB25';
const AMBER_TEXT = '#998200';

export const getRatingColors = (rating: number): { borderColor: string; textColor: string } => {
  if (rating < 3) {
    return {
      borderColor: `var(${themeVariables.colors.stroke.negative})`,
      textColor: `var(${themeVariables.colors.content.negative})`,
    };
  }

  if (rating < 4) {
    return { borderColor: AMBER_BORDER, textColor: AMBER_TEXT };
  }

  return {
    borderColor: `var(${themeVariables.colors.stroke.positive})`,
    textColor: `var(${themeVariables.colors.content.positive})`,
  };
};

export const pill = (rating: number) => {
  const { borderColor, textColor } = getRatingColors(rating);

  return css`
    display: inline-block;
    width: fit-content;
    border: 1px solid ${borderColor};
    border-radius: var(${themeVariables.borderRadius.full.mobile});
    padding: calc(var(${themeVariables.spacing.xxs}) / 4) var(${themeVariables.spacing.xs});
    color: ${textColor};
    font-family: var(${themeVariables.typography.body.fontFamily}, sans-serif);
    font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  `;
};
